import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import LandingPage from './pages/LandingPage';
import FormSelect from './pages/FormSelect';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AdminDashboard from './pages/AdminDashboard';
import MyFilings from './pages/MyFilings';
import FilingView from './pages/FilingView';
import NewFiling from './pages/NewFiling';
import Page1 from './pages/Page1';
import Page2 from './pages/Page2';
import Page3 from './pages/Page3';
import ExciseAbatementPage1 from './pages/ExciseAbatementPage1';
import ExciseAbatementPage2 from './pages/ExciseAbatementPage2';
import SiteFooter from './pages/SiteFooter';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
<Route path="/form-select" element={<FormSelect />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/my-filings" element={<MyFilings />} />
        <Route path="/filing-view" element={<FilingView />} />
        <Route path="/new-filing" element={<NewFiling />} />
        <Route path="/page1" element={<Page1 />} />
        <Route path="/page2" element={<Page2 />} />
        <Route path="/page3" element={<Page3 />} />
        <Route path="/excise-abatement" element={<ExciseAbatementPage1 />} />
        <Route path="/excise-abatement-page2" element={<ExciseAbatementPage2 />} />
      </Routes>
      <SiteFooter />
    </Router>
  );
}

export default App;